import { createApiV2 } from "../common";

export const getCompanySchemas = () => (token) =>
  createApiV2("GET", "dynamic_schema/company_schemas/")(token);

export const getSavedCustomSchemas = () => (token) =>
  createApiV2("GET", "dynamic_schema/company_schemas/")(token, {
    is_custom: "true",
    sort_by_index: "true",
  });

export const getCustomSchemaTypes = () => (token) =>
  createApiV2("GET", "dynamic_schema/schema_types/")(token);

export const postCompanySchemas = (payload) => (token) =>
  createApiV2("POST", "dynamic_schema/company_schemas/")(token, payload);

export const patchCompanySchemas =
  ({ uid, payload }) =>
  (token) =>
    createApiV2("PATCH", `dynamic_schema/company_schemas/${uid}/`)(token, payload);

export const deleteCustomSchema = (uid) => (token) =>
  createApiV2("DELETE", `dynamic_schema/company_schemas/${uid}/`)(token);

export const patchReorderCompanySchemas = (payload) => (token) =>
  createApiV2("PATCH", "dynamic_schema/company_schemas/reorder/")(token, payload);

export const getPublicCompanySchemas = (orderToken) => () =>
  createApiV2("GET", "dynamic_schema/company_schemas/public/")(null, {
    token: orderToken,
    is_custom: "true",
    sort_by_index: "true",
  });

export default {};
